import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "ui-component/Loadable";
import MainLayout from "layout/MainLayout";
import RoleProtected from "components/RoleProtected";
const RootRedirect = () => {
  const token = localStorage.getItem("token");
  const isValid = token && token !== "undefined" && token !== "null";
  return isValid ? <Navigate to="/dashboard" replace /> : <Navigate to="/auth/login" replace />;
};

const Dashboard = Loadable(lazy(() => import("views/dashboard/Default")));
const PropertyList = Loadable(lazy(() => import("views/property/PropertyList")));
const PropertyDetails = Loadable(lazy(() => import("views/property/PropertyDetails")));
const AddProperty = Loadable(lazy(()=>import("views/property/AddProperty")));
const EditProperty = Loadable(lazy(() => import("views/property/EditProperty")));
const KycList = Loadable(lazy(() => import("views/kyc/KycList")));
const KycDetails = Loadable(lazy(() => import("views/kyc/KycDetails")));
const InvestmentList = Loadable(lazy(() => import("views/investment/InvestmentList")));
const InvestmentDetails = Loadable(lazy(() => import("views/investment/InvestmentDetails")));
const ReferralEarnings = Loadable(lazy(() => import("views/referral/ReferralEarnings")));
const UserList = Loadable(lazy(() => import("views/users/UserList")));
const UserDetails = Loadable(lazy(() => import("views/users/UserDetails")));
const ContactList = Loadable(lazy(() => import("views/contact/ContactList")));
const RoleManagement = Loadable(lazy(() => import("views/role/RoleManagement")));
const RoleAssignment = Loadable(lazy(() => import("views/role/RoleAssignment")));
const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/",
      element: <RootRedirect />
    },
    {
      path: "dashboard",
      element: <RoleProtected><Dashboard /></RoleProtected>,
    },
    {
      path: "property",
      element: <RoleProtected><PropertyList /></RoleProtected>,
    },
    {
      path: "property/add",
      element: <RoleProtected><AddProperty /> </RoleProtected>,
    },
    {
      path: "property/edit/:id",
      element: <RoleProtected><EditProperty /> </RoleProtected>,
    },
    {
      path: "property/:id",
      element: <RoleProtected><PropertyDetails /> </RoleProtected>,
    },
    {
      path: "kyc",
      element: <RoleProtected><KycList /></RoleProtected>,
    },
    {
      path: "kyc/:userId",
      element: <RoleProtected><KycDetails /></RoleProtected>,
    },
    {
      path: "investment",
      element: <RoleProtected><InvestmentList /></RoleProtected>,
    },
    {
      path: "investment/:id",
      element: <RoleProtected><InvestmentDetails /></RoleProtected>,
    },
    {
      path: "referral",
      element: <RoleProtected><ReferralEarnings /></RoleProtected>,
    },

    {
      path: "users",
      element: <RoleProtected><UserList /></RoleProtected>,
    },
    {
      path: "users/:id",
      element: <RoleProtected><UserDetails /></RoleProtected>,
    },
    {
      path: "contacts",
      element: <RoleProtected><ContactList /></RoleProtected>,
    },
    {
      path: "roles",
      element: <RoleProtected><RoleManagement /></RoleProtected>,
    },
    {
      path: "roles/assignment",
      element: <RoleProtected><RoleAssignment /></RoleProtected>,
    },
  
    {
      path: "*",
      element: <Navigate to="/" replace />
    }
  ]
};

export default MainRoutes;